import { palette } from './palette';

export const homeStyle = {
  /* Login */
  '.login-root': {
    '& .hero-shaped__wrapper': {
      maxWidth: 'unset',
      minHeight: 'unset !important',

      '& .logo-image': {
        width: '120px !important',
      },
    }
  },

  '.dental-depot-container': {
    /* General Styles */
    '& .text-highlight': {
      color: palette.text.highlight
    },

    /* Hero Section - Styles */
    '& .home-hero-wrapper': {
      background: palette.background.main,

      '& .section-alternate__content': {
        padding: '0 48px',

        '@media(max-width: 1200px)': {
          padding: 48,
        },
      },
      '& .hero-section-alternate': {
        height: 'auto !important',
        paddingBottom: 0,
      },
      '& .hero-title': {
        maxWidth: 550,
        lineHeight: 1.4,
        fontWeight: 500,
      },
      '& .hero-subtitle': {
        maxWidth: 600,
        fontSize: 20,
        fontWeight: 400,
        lineHeight: 1.75,
        margin: '20px 0px',
      },
      '& .image-wrapper': {
        position: 'relative',
        '@media(min-width: 900px)': {
          bottom: -85,
        },
  
        '& .image': {
          boxShadow: 'none',
        },
      },
    },

    /* Benefits - Styles */
    '& #definition-section': {
      '@media(min-width: 900px)': {
        paddingTop: 150,
      },
      '& .benefits-wrapper': {
        padding: '0 24px',
  
        '@media(min-width: 900px)': {
          padding: '0 48px',
        }
      },
      '& .section-header': {
        '@media(min-width: 900px)': {
          paddingBottom: 50,
        },
      },
      '& .definition-service-tile': {
        '& .definition-service-innertile': {
          height: '100%',

          '& .definition-service-description': {
            paddingBottom: 48,
            minHeight: 109,
            borderBottom: `1px solid ${palette.text.primary}`,
          }
        },
      },
    },

    /* Pricing & Benefits / Subscription - Styles */
    '& .subscription-wrapper': {
      '& .subscription-bg': {
        height: '100%',
        backgroundColor: palette.primary.main,
      },
      '& .plans-loader': {
        color: palette.primary.contrastText,
      },
      '& #pricing-benefit-section': {
        paddingBottom: 48,

        '& .MuiSwitch-root': {
          width: 46,
          height: 28,

          '& .MuiButtonBase-root': {
            padding: 4,
          },
          '& .MuiSwitch-thumb': {
            color: '#FFCB49',
          },
          '& .MuiSwitch-track': {
            backgroundColor: palette.text.highlight,
            borderRadius: 14,
          },
        },

        '& .subscription-tabs-label': {
          color: palette.text.highlight,
        },

        '& .planCard': {
          '&:hover': {
            backgroundColor: palette.background.main,
            color: palette.text.primary,

            '& .highlight-divider': {
              background: palette.primary.main,
            }
          },
        },
        '& .summary-text': {
          color: palette.text.highlight
        },
        '& .offer-text': {
          fontSize: 20,
          color: palette.text.highlight,
  
          '& .savings-summary-link': {
            color: '#FFCB49 !important',
            textDecoration: 'underline',
            cursor: 'pointer',
          },
        },
        '& .react-multi-carousel-dot button': {
          opacity: 0.2,
          background: palette.text.highlight,
        },
        '& .react-multi-carousel-dot--active button': {
          opacity: 1,
        },
      },
    },

    /* How it works - Styles */
    '& .howitworks-section': {
      background: palette.background.default,

      '& .how-cover-image': {
        height: 'auto',
      },

      '& .howitworks-title': {
        marginBottom: 16,

        '@media(min-width: 900px)': {
          marginBottom: 60,
        }
      },

      '& .working-steps-container': {
        borderBottom: `1px solid ${palette.text.disabled}`,
        maxWidth: 533,
        paddingBottom: 32,
      },
    },

    /* Testimonial - Styles */
    '& .testimonial-wrapper': {
      backgroundColor: palette.background.main,

      '& .testimonialSection': {
        padding: '40px 32px',
  
        '@media(min-width: 900px)': {
          padding: '40px 16px 80px',
        },
        '& .testimonial-container': {
          '& .react-multi-carousel-dot button': {
            background: palette.text.primary,
          },
          '& .testimonial-message': {
            color: palette.text.primary,
            fontWeight: 500,
          },
          '& .testimonial-name': {
            color: palette.text.primary,
          },
        },
      },
    },

    /* Static hero section */
    '& .home-static-hero-wrapper': {
      '& .hero-static-bg': {
        backgroundColor: palette.background.paper,
      },
    },

    /* Checkout Page */
    '& .checkout-flow-container': {
      '& .provider-details': {
        border: `1px solid ${palette.text.disabled}`,
      },

      '&.plan-selection-container': {
        '& .planCard': {
          '&:hover': {
            color: palette.text.primary,

            '& .highlight-button': {
              color: palette.text.highlight,
            },
            '& .highlight-divider': {
              background: palette.primary.main,
            }
          },
        },
      },

      /* Static hero section */
      '& .home-static-hero-wrapper': {
        '& .hero-static-bg': {
          backgroundColor: palette.background.main,
        },
      },
    },

    /* Create Subscriber - Checkout */
    '& .checkout-outer-container': {
      '& .payment-title-root': {
        marginTop: 0
      },
      '& .promo-spinner': {
        backgroundColor: 'unset',
      },
    },

    /* Faq & success - contact card */
    '& .faq-contact-wrapper': {
      '& .section-header__subtitle-wrapper p': {
        maxWidth: 600,
      },
    },

    /* Savings summary */
    '& .savings-wrapper': {
      '& .service-plan-table .savings-topheader': {
        color: `${palette.primary.contrastText} !important`,
      },
    },

    /* Subscription Success */
    '& .success-wrapper': {
      '& .mail-link': {
        color: palette.text.primary,
      },
    },

    /* Footer Disclosure */
      '& .footer-wrapper': {
        backgroundColor: palette.background.paper
      },
     

    /* Book Appointment */
    '& .morning-image, & .noon-image, & .evening-image': {
      fill: `${palette.primary.main} !important`,
    },
  },
};